module.exports = __webpack_public_path__ + "img/apart04.201a4d2d.png";